import { MutableRefObject, useLayoutEffect } from 'react'

export default function useScrollRestoration(
  key: string,
  containerRef: MutableRefObject<HTMLElement | null> | null
) {
  const containerElement = containerRef?.current
  useLayoutEffect(() => {
    if (containerElement) {
      // 当组件加载时，尝试恢复滚动位置
      const scrollPosition = sessionStorage.getItem(key)
      if (scrollPosition) {
        const container = containerElement
        container.scrollTop = Number(scrollPosition)
        sessionStorage.removeItem(key)
      }
    }
    return () => {
      if (containerElement) {
        const container = containerElement
        sessionStorage.setItem(key, String(container.scrollTop))
      }
    }
  }, [containerElement, key])
}
